import lottie from 'lottie-web'

export const selector = '.audio'

export default (
    el = null
) => {
    if (!el)
        return

    const audio = el.querySelector('audio')
    const btn = el.querySelector('.btn')

    if (!audio
        || !btn)
        return

    console.groupCollapsed('Audio')

    const animation = el.querySelector('.audio-lottie')
    const medias = document.querySelectorAll('audio')
    const playingCss = 'audio-playing'
    const { animationPath } = animation.dataset

    const playAnimation = lottie.loadAnimation({
        container: animation,
        loop: true,
        autoplay: false,
        path: animationPath || ''
    })

    const lottieAnimations = lottie
        .getRegisteredAnimations()

    const stopAll = () => {
        if (!medias)
            return

        medias.forEach(item => {
            if (item !== audio) {
                item.pause()

                const itemWrapper = item
                    .closest(`.${playingCss}`)

                if (!itemWrapper)
                    return

                itemWrapper
                    .classList.remove(playingCss)

                const itemAudio = itemWrapper
                    .querySelector('.audio-lottie')

                lottieAnimations.forEach(anim => {
                    if (anim.wrapper === itemAudio)
                        anim.stop()
                })
            }
        })
    }

    const audioControl = () => {
        stopAll()

        if (audio.paused) {
            audio.play()
            playAnimation.play()
        }
        else {
            audio.pause()
            playAnimation.stop()
        }

        el.classList.toggle(playingCss)
    }

    const audioEnded = () => {
        el.classList.toggle(playingCss)

        playAnimation.stop()
    }

    btn.addEventListener('click',
        audioControl)

    audio.addEventListener('ended',
        audioEnded)

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                if (btn)
                    btn.removeEventListener('click',
                        audioControl)

                if (audio)
                    audio.removeEventListener('ended',
                        audioEnded)

                if (playAnimation)
                    playAnimation.destroy()
            })

    // Log els
    console.log(el)

    console.groupEnd()

    return el
}
